(function () {
  'use strict';
  var SELECTOR = '.product__info-container .product__description';

  function chevron() {
    return '<svg class="tq-pd__chev" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M4 6l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function enhance(desc) {
    if (!desc || desc.getAttribute('data-tq-pd') === '1') return;
    if (desc.closest('.tq-pd')) return;
    desc.setAttribute('data-tq-pd', '1');

    var details = document.createElement('details');
    details.className = 'tq-pd';

    var summary = document.createElement('summary');
    summary.className = 'tq-pd__summary';
    summary.innerHTML = '<span class="tq-pd__label">Product Details</span>' + chevron();

    var parent = desc.parentNode;
    if (!parent) return;
    parent.insertBefore(details, desc);
    details.appendChild(summary);
    details.appendChild(desc);
  }

  function init() {
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) enhance(nodes[i]);

    var container = document.querySelector('.product__info-container');
    if (container && window.MutationObserver) {
      var mo = new MutationObserver(function () {
        var d = container.querySelector('.product__description:not([data-tq-pd])');
        if (d) enhance(d);
      });
      mo.observe(container, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
